/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */

import store from '../../redux/store';

class Authenticated {
  constructor() {
    this.authenticated = true;
    this.memberName = '';
  }

  login(callBack) {
    this.authenticated = true;
    localStorage.setItem('isAuth', true);
    callBack();
  }

  logout(callBack) {
    this.authenticated = false;
    localStorage.removeItem('isAuth');
    localStorage.removeItem('enableIntegration');
    callBack();
  }

  getMemberName() {
    return this.memberName;
  }

  setMemberName(firstName) {
    this.memberName = firstName;
  }

  isAuthenticated() {
    this.authenticated = store.getState().user.isLoggedIn;
    return this.authenticated;
  }
}

export default new Authenticated();
